module.exports = __webpack_public_path__ + "img/icon-user.2355e432.png";